<!-- @format -->

<template>
  <div>
    <div class="container">
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <b-form class="container mb-3" @submit.stop.prevent="save">
            <b-row>
              <b-col sm="12" md="12" lg="12" xl="12">
                <b-form-group label-size="md">
                  <template slot="label"> Company name</template>
                  <b-form-input
                    name="companyName"
                    maxlength="200"
                    :value="form.companyName"
                    @change="setValue('companyName', $event)"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="12" xl="12">
                <b-form-group label-size="md">
                  <template slot="label"> Commercial name</template>
                  <b-form-input
                    name="companyName"
                    maxlength="200"
                    :value="form.commercialName"
                    @change="setValue('commercialName', $event)"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="12" xl="12">
                <b-form-group label-size="md">
                  <template slot="label">
                    Address
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-if="isAddressSelected"
                    v-model="address"
                    size="md"
                    name="street"
                    class="mb-1"
                    maxlength="65"
                    @focus="isAddressSelected = false"
                  />
                  <place-autocomplete-field
                    v-else
                    v-model="address"
                    v-place-autofill:street="form.street"
                    v-place-autofill:city="form.cityId"
                    v-place-autofill:state="form.state"
                    v-place-autofill:zipcode="form.zip"
                    name="address"
                    :api-key="$config.apiKeys.googleMaps"
                    placeholder="Enter an an address, zipcode, or location"
                    country="us"
                    @autocomplete-select="selectAddress"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="12" xl="12">
                <b-form-group label-size="md">
                  <template slot="label"> Address line 2 </template>
                  <b-form-input
                    name="addressLine2"
                    maxlength="200"
                    :value="form.addressLine2"
                    @change="setValue('addressLine2', $event)"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label">
                    Street
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model.trim="$v.form.street.$model"
                    required
                    size="sm"
                    name="street"
                    maxlength="65"
                    :value="form.street"
                    :state="validateState('street')"
                    @change="setValue('street', $event)"
                  />
                  <b-form-invalid-feedback>
                    <div v-if="!$v.form.street.required">
                      This field is required
                    </div>
                    <div v-if="!$v.form.street.maxLength">
                      Character limit reached
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label">
                    ZIP postal code
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model.trim="$v.form.zip.$model"
                    required
                    size="sm"
                    name="zip"
                    maxlength="10"
                    :value="form.zip"
                    :state="validateState('zip')"
                    @change="setValue('zip', $event)"
                  />
                  <b-form-invalid-feedback>
                    <div v-if="!$v.form.zip.required">
                      This field is required
                    </div>
                    <div v-if="!$v.form.zip.maxLength">
                      Character limit reached
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label">
                    State
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model.trim="$v.form.state.$model"
                    disabled
                    required
                    size="sm"
                    name="state"
                    maxlength="250"
                    :value="form.state"
                    :state="validateState('state')"
                    @change="setValue('state', $event)"
                  />
                  <b-form-invalid-feedback>
                    <div v-if="!$v.form.state.required">
                      This field is required
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label">
                    City
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model.trim="$v.form.cityId.$model"
                    disabled
                    required
                    size="sm"
                    name="city"
                    maxlength="250"
                    :value="form.cityId"
                    :state="validateState('cityId')"
                    @change="setValue('cityId', $event)"
                  />
                  <b-form-invalid-feedback>
                    <div v-if="!$v.form.cityId.required">
                      This field is required
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Website </template>
                  <b-form-input
                    v-model.trim="form.webSite"
                    size="sm"
                    name="webSite"
                    placeholder="www.yourSite.com"
                    maxlength="65"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6" class="mr-0">
                <b-form-group label="Logo">
                  <b-input-group>
                    <b-form-file
                      id="file-contract"
                      v-model="form.img"
                      accept=".png, .jpg, .jpeg"
                    />
                    <b-input-group-append
                      v-if="corporationItem.logo && form.img == null"
                    >
                      <b-button variant="none">
                        <a :href="corporationItem.logo" target="_blank">
                          <b-icon icon="eye" variant="dark-green" />
                        </a>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Currency type </template>
                  <b-form-select
                    v-model.trim="form.typeCurrency"
                    size="md"
                    name="typeCurrency"
                    :options="typesOfCurrency"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Corporation color </template>
                  <b-form-input
                    v-model.trim="form.color"
                    size="sm"
                    name="color"
                    type="color"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Marketplace </template>
                  <multiselect
                    v-model="form.marketplace"
                    :options="marketPlaceList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Pick some option"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} options selected</span
                      ></template
                    >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6" xl="6">
                <b-form-group label-size="md">
                  <template slot="label"> Export </template>
                  <b-form-checkbox
                    size="lg"
                    v-model="form.export"
                    :value="1"
                    :unchecked-value="0"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" lg="6" xl="6" class="mb-4" />
              <b-col sm="12" md="3" lg="3" xl="3" class="mb-4" />
              <b-col sm="12" md="3" lg="3" xl="3" class="mb-4">
                <b-button
                  class="float-right"
                  variant="success"
                  type="submit"
                  block
                  :disabled="$v.form.$invalid"
                >
                  <b-spinner
                    v-if="corporation.status == 'fetching'"
                    small
                    variant="white"
                  />
                  <span v-else>Save</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { POST_CORPORATION } from "./actions";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  props: ["corporationItem", "refreshData", "hideModal"],
  components: {
    Multiselect,
  },
  data() {
    return {
      isAddressSelected: false,
      address: null,
      form: {
        password: "",
        confirmPassword: "",
        fullName: "",
        street: "",
        zip: "",
        state: "",
        cityId: "",
        webSite: "",
        companyName: "",
        addressLine2: "",
        typeCurrency: null,
        color: null,
        marketplace: null,
        export: 0,
      },
      states: [],
      cities: [],
      showPassword: false,
      showConfirmPassword: false,
      typesOfCurrency: [
        { value: "USD", text: "USD" },
        { value: "CAD", text: "CAD" },
      ],
      marketPlaceList: [],
    };
  },
  validations: {
    form: {
      street: {
        required,
        maxLength: maxLength(250),
      },
      zip: {
        required,
        maxLength: maxLength(10),
      },
      state: {
        required,
      },
      cityId: {
        required,
      },
    },
  },
  computed: {
    ...mapState({
      corporation: (state) => state.masterUser.corporation.corporation,
    }),
  },
  mounted() {
    this.getMarketPlaceList();
    if (this.corporationItem.id) {
      this.formatForm();
    }
  },
  methods: {
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    save() {
      const payload = this.formatPayload();
      this.$store
        .dispatch(POST_CORPORATION, payload)
        .then(() => {
          this.$root.$bvToast.toast("Information successfully saved", {
            title: "Success",
            variant: "success",
          });

          this.hideModal();
          this.refreshData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    formatPayload() {
      const data = new FormData();
      if (this.corporationItem.id) {
        data.append("id", this.corporationItem.id);
      }
      data.set("street", this.form.street);
      data.set("zip", this.form.zip);
      data.set("state", this.form.state);
      data.set("city", this.form.cityId);
      data.set("webSite", this.form.webSite);
      data.set("companyName", this.form.companyName);
      data.set("addressLine2", this.form.addressLine2);
      data.set("commercialName", this.form.commercialName);
      data.set("color", this.form.color);
      data.set("img", this.form.img);
      data.set("marketplaceId", this.form.marketplace.id);
      data.set("export", this.form.export);
      if (this.form.typeCurrency) {
        data.set("typeCurrency", this.form.typeCurrency);
      }
      return data;
    },

    formatForm() {
      this.form.id = this.corporationItem.id;
      this.form.street = this.corporationItem.street;
      this.form.zip = this.corporationItem.zip;
      this.form.state = this.corporationItem.state;
      this.form.cityId = this.corporationItem.city;
      this.form.webSite = this.corporationItem.webSite;
      this.form.companyName = this.corporationItem.companyName;
      this.form.addressLine2 = this.corporationItem.addressLine2;
      this.form.commercialName = this.corporationItem.commercialName;
      this.form.img = this.corporationItem.img;
      this.form.typeCurrency = this.corporationItem.typeCurrency;
      this.form.color = this.corporationItem.color;
      this.form.marketplace = this.marketPlaceList.find(
        (item) => item.id === this.corporationItem.marketplaceId
      );
      this.form.export = this.corporationItem.export;
    },

    getMarketPlaceList() {
      this.$store.dispatch("GET_MARKETPLACE_LIST").then((response) => {
        this.marketPlaceList = response;
        if (this.corporationItem.id) {
          this.formatForm();
        }
      });
    },

    selectAddress() {
      this.isAddressSelected = true;
    },
  },
};
</script>

<style></style>
